import { h, Host } from "@stencil/core";
import { setCurrencySymbol } from "../../utils/setCurrencySymbol";
export class NumberFormat {
    constructor() {
        this.value = undefined;
        this.locale = "";
        this.currency = false;
        this.formattedNumber = "";
        this.currencyStr = "";
    }
    useSetCurrencySymbol() {
        // @ts-expect-error Check for typing
        this.currencyStr = setCurrencySymbol(this.locale);
    }
    formatNumber() {
        const { value, locale, currency } = this;
        if (currency) {
            this.formattedNumber = new Intl.NumberFormat(locale, {
                style: "currency",
                currency: `${this.currencyStr}`
            }).format(value);
        }
        else if (locale === "" && !currency) {
            this.formattedNumber = new Intl.NumberFormat().format(value);
        }
        else {
            this.formattedNumber = new Intl.NumberFormat(locale).format(value);
        }
    }
    componentWillLoad() {
        this.useSetCurrencySymbol();
        this.formatNumber();
    }
    render() {
        return h(Host, { key: '0c449b3e9fe745d30c868c9acab4be80187c7250', class: "ux-number-format" }, this.formattedNumber);
    }
    static get is() { return "ux-number-format"; }
    static get properties() {
        return {
            "value": {
                "type": "number",
                "mutable": false,
                "complexType": {
                    "original": "number",
                    "resolved": "number",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "The value to format; must be formatted as a JS number (e.g. 1000 or 14.00)"
                },
                "attribute": "value",
                "reflect": false
            },
            "locale": {
                "type": "string",
                "mutable": false,
                "complexType": {
                    "original": "string",
                    "resolved": "string | undefined",
                    "references": {}
                },
                "required": false,
                "optional": true,
                "docs": {
                    "tags": [],
                    "text": "Locale can be set optionally; the browser locale is used as default (e.g. 'de-DE')"
                },
                "attribute": "locale",
                "reflect": false,
                "defaultValue": "\"\""
            },
            "currency": {
                "type": "boolean",
                "mutable": false,
                "complexType": {
                    "original": "boolean",
                    "resolved": "boolean | undefined",
                    "references": {}
                },
                "required": false,
                "optional": true,
                "docs": {
                    "tags": [],
                    "text": "Set when you want to display number with currency"
                },
                "attribute": "currency",
                "reflect": false,
                "defaultValue": "false"
            }
        };
    }
    static get states() {
        return {
            "formattedNumber": {},
            "currencyStr": {}
        };
    }
    static get watchers() {
        return [{
                "propName": "locale",
                "methodName": "useSetCurrencySymbol"
            }, {
                "propName": "value",
                "methodName": "formatNumber"
            }, {
                "propName": "currency",
                "methodName": "formatNumber"
            }, {
                "propName": "locale",
                "methodName": "formatNumber"
            }];
    }
}
//# sourceMappingURL=number-format.js.map
